document.addEventListener("DOMContentLoaded", function(){
    let swiperInstance = null;

    function initSwiper() {
        if (window.innerWidth < 1200 && !swiperInstance) {
            swiperInstance = new Swiper(".ForWhom.swiper-container", {
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: true,
                pagination: {
                    el: '.swiper-pagination-for',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 15
                    },
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    }
                }
            });
        } else if (window.innerWidth >= 1200 && swiperInstance) {

            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }

    initSwiper();

    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initSwiper, 250);
    });
});
/*

document.addEventListener("shopify:section:load", function(){
    let swiperInstance = null;

    function initSwiper() {
        // Check if window width is below 1200px
        if (window.innerWidth < 1200 && !swiperInstance) {
            swiperInstance = new Swiper(".ForWhomBlock-Containers", {
                slidesPerView: 'auto',
                spaceBetween: 20,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 15
                    },
                    // when window width is >= 768px
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    }
                }
            });
        } else if (window.innerWidth >= 1200 && swiperInstance) {
            // Destroy swiper when window is 1200px or wider
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }

    // Reinitialize swiper when shopify section loads
    initSwiper();

    // Handle window resize with debounce to prevent performance issues
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initSwiper, 250);
    });
});*/
